module.exports = __webpack_public_path__ + "static/media/testimonial_img.99b2de0a.png";